import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"
import { Loader } from "../s22_loader"

import { StudentLoginCmp, StudentLoginCmpProps } from "./StudentLogin"
import { StyledMain } from "./partials"

interface StudentLoginWBlokProps {
  blok: StudentLoginCmpProps & blokType
  isDark?: boolean
}

export const StudentLogin: React.FC<StudentLoginWBlokProps> = ({
  blok,
  isDark,
}) => {
  const [iframeLoaded, setiframeLoaded] = React.useState(false)

  if (typeof window !== "undefined") {
    window.addEventListener(
      "message",
      (event) => {
        if (event.data === "content-loaded") {
          setiframeLoaded(true)
        }
      },
      false
    )
  }


  return (
    <SbEditable content={blok}>
      <StyledMain method={blok.method}>
        {!iframeLoaded && <Loader form_count={10} />}
        <StudentLoginCmp
            student_app_3={blok.student_app_3}
          loaded={iframeLoaded}
          programGrouping={blok.programGrouping}
          method={blok.method}
          is_dark={isDark}
        ></StudentLoginCmp>
      </StyledMain>
    </SbEditable>
  )
}
